export default "__VITE_ASSET__xkXVun7a__"